var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 55,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#139C33",
    fillRule: "evenodd",
    d: "M14.201.833h20.575c8.569 0 13.7 5.204 13.724 13.893v25.548c0 8.688-5.109 13.892-13.701 13.892h-7.617a1.945 1.945 0 0 1-1.716-1.942c0-.997.74-1.834 1.716-1.943h7.594c6.548 0 9.846-3.367 9.846-10.007V14.726c0-6.64-3.298-10.008-9.846-10.008H14.2c-6.549 0-9.87 3.367-9.87 10.008v25.548c0 6.64 3.321 10.007 9.87 10.007.977.11 1.716.946 1.716 1.943 0 .996-.74 1.833-1.716 1.942C5.632 54.166.5 48.963.5 40.274V14.726C.5 6.013 5.632.833 14.201.833Zm.673 17.33h7.315a1.945 1.945 0 0 0 1.717-1.942c0-.997-.74-1.834-1.717-1.943h-7.315a1.945 1.945 0 0 0-1.716 1.943c0 .996.74 1.833 1.716 1.942Zm19.205 11.28H14.851a1.945 1.945 0 0 1-1.716-1.943c0-.997.74-1.834 1.716-1.943H34.08a1.919 1.919 0 0 1 1.844.904 1.978 1.978 0 0 1 0 2.077 1.919 1.919 0 0 1-1.844.904Zm0 11.278H14.851c-1.051 0-1.904-.864-1.904-1.93 0-1.067.853-1.931 1.904-1.931H34.08c1.052 0 1.904.864 1.904 1.93 0 1.067-.852 1.931-1.904 1.931Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiy);
export default __webpack_public_path__ + "static/media/verifiy.6b5ac1ede373a58e2b9733db97e49324.svg";
export { ForwardRef as ReactComponent };